var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileUploadImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0.5L12.1325 5H5C2.525 5 0.5 7.025 0.5 9.5V36.5C0.5 38.975 2.525 41 5 41H41C43.475 41 45.5 38.975 45.5 36.5V9.5C45.5 7.025 43.475 5 41 5H33.8675L29.75 0.5H16.25ZM23 34.25C16.79 34.25 11.75 29.21 11.75 23C11.75 16.79 16.79 11.75 23 11.75C29.21 11.75 34.25 16.79 34.25 23C34.25 29.21 29.21 34.25 23 34.25Z",
    fill: "#79C6EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileUploadImage);
export default __webpack_public_path__ + "static/media/mobile-upload-image.8e68c5c1883f3ac2866957ab897b122b.svg";
export { ForwardRef as ReactComponent };